import React from 'react';
import { buro2CSS } from './Buro2.css';
import { buroFemenino, buroMasculino } from '../../../../../Assets/Images';
import { InputText } from 'primereact/inputtext';
import 'primeicons/primeicons.css';
import axios from 'axios';
import { Button } from 'primereact/button';
import { formatDate } from '../functions';

function Buro2({state, userData, setUserData}) {
    function buroRequest(){
        let form = [
            userData.birthday,
            userData.rfc,
            userData.address,
        ]

        for(let i=0; i<form.length; i++){
            if(!form[i])
                return;
        }

        axios.get('https://peicar.linda-bi.app/tokenPFM')
        .then( res => {
            let token = res.access_token;

            axios.post(
                //buro_informe_api // PM MOCK
                'https://api.burodecredito.com.mx:4431/devpf/informe-buro/credit-report-api/v1/informe-buro'
                ,
                // PF MOCK
             //    {
             //       "consulta": {
             //          "persona": {
             //             "domicilios": [
             //                {
             //                   "ciudad": "CIUDAD DE MEXICO",
             //                   "codPais": "MX",
             //                   "cp": "02099",
             //                   "delegacionMunicipio": "AZCAPOTZALCO",
             //                   "direccion1": "AZCAPOTZALCO 202 403",
             //                   "direccion2": "",
             //                   "estado": "CDMX"
             //                }
             //             ],
             //             "encabezado": {
             //                "clavePais": "MX",
             //                "claveUnidadMonetaria": "MX",
             //                "identificadorBuro": "",
             //                "idioma": "SP",
             //                "numeroReferenciaOperador": "",
             //                "productoRequerido": "001",
             //                "tipoConsulta": "I",
             //                "tipoContrato": "AL"
             //             },
             //             "nombre": {
             //                "apellidoMaterno": "GONZALEZ",
             //                "apellidoPaterno": "GONZALEZ",
             //                "primerNombre": "ARMANDO",
             //                "rfc": "GOGA990629Q78",
             //                "fechaNacimiento": "01051997" // opcional
             //             }
             //          }
             //       }
             //    }
                 {
                     "consulta": {
                     "persona": {
                         "domicilios": [
                             {
                                 "ciudad": state.rodac.ciudad,
                                 "codPais": "MX",
                                 "cp": state.rodac.zip,
                                 "delegacionMunicipio": state.rodac.municipio,
                                 "direccion1": userData.address,
                                 "direccion2": "",
                                 "estado": state.rodac.estado
                             }
                         ],
                         "encabezado": {
                             "clavePais": "MX",
                             "claveUnidadMonetaria": "MX",
                             "identificadorBuro": "",
                             "idioma": "SP",
                             "numeroReferenciaOperador": "                         ",
                             "productoRequerido": "001",
                             "tipoConsulta": "I",
                             "tipoContrato": "AL"
                         },
                         "nombre": {
                             "apellidoMaterno": state.rodac.materno,
                             "apellidoPaterno": state.rodac.paterno,
                             "primerNombre": state.rodac.name,
                             "rfc": userData.rfc,
                             "fechaNacimiento": formatDate(userData.birthday) // opcional
                         }
                     }
                     }
                 }
                ,
                {
                   headers: {
                      //Authorization: "Bearer b02bdcbe-8332-4b7f-a411-6f0bba2c7f1c" // PM MOCK
                      Authorization: `Bearer ${token}` // PF MOCK
                   }
                }
             ).then(res => {
                // console.log(res.data)
             }).catch(err => {
                console.log(err)
             })
        })
        .catch(err => {
            console.log(err);
        })

        
     }
    return (
        <div css={buro2CSS()}>
            {/* <div className="Background" /> */}
            <div className='TopText w-5 mb-6'>
                Ahora necesitamos confirmar tu identidad para consultar tu buró
            </div>

            <div className="FormContainer">
                <div className="grid mb-1">
                    <div className="col-8 Column">
                        <span className='BlackText'>
                            ¿Cuál es tu género?
                        </span>
                    </div>

                    <div className="col-2 Column IconContainer">
                        <div className="SelectionDiv">
                            <img src={buroMasculino} />
                            <span>Masculino</span>
                        </div>
                    </div>

                    <div className="col-2 Column IconContainer">
                        <div className="SelectionDiv">
                            <img src={buroFemenino} />
                            <span>Femenino</span>
                        </div>
                    </div>
                </div>

                <div className="grid">
                    <div className="col">
                        <span className="p-input-icon-left w-full">
                            <i className="pi pi-dollar" />
                            <InputText
                                //{...register("email", { required: true, pattern: /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z\s]{2,}))$/ })}
                                placeholder='Ingreso mensual promedio'
                                className={'TextInput pl-5 font-bold'}
                            />
                        </span>
                    </div>
                </div>

                {/* <div className="grid">
                    <div className="col Paragraph">
                        <span className='BlackText'>
                            Ingresa tu clave privada CIEC y contraseña para autorizar la consulta de
                            tu historial crediticio.
                        </span>
                        <span className='Disclaimer'>
                            Esta información nos ayudará para un mejor cálculo de las condiciones de tu financiamiento.
                        </span>
                    </div>
                </div>

                <div className="grid">
                    <div className="col">
                        <InputText
                            //{...register("email", { required: true, pattern: /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z\s]{2,}))$/ })}
                            placeholder='CIEC'
                            className={'TextInput pl-5 font-bold'}
                        />
                    </div>
                    <div className="col">
                        <InputText
                            //{...register("email", { required: true, pattern: /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z\s]{2,}))$/ })}
                            placeholder='Contraseña CIEC'
                            className={'TextInput pl-5 font-bold'}
                        />
                    </div>
                </div> */}

                <div className="grid">
                    <div className="col CheckboxRow">
                        <input type="checkbox" />
                        <span className='BlackText'>Declaración de veracidad de información</span>
                    </div>
                </div>

                <div className="grid">
                    <div className="col Paragraph">
                        <span className='Disclaimer'>
                            Autorizo expresamente a CONDUCE CAPITAL SAPI DE CV., para llevar a cabo investigaciones sobre mi comportamiento crediticio en las sociedades de información crediticia (SIC) que estime conveniente.
                            Conozco la naturaleza y alcance de la información que se solicitará, del uso se le dará y que se podrán realizar consultas periódicas de mi historial crediticio. Consiento que esta autorización tenga una vigencia de 3 años contados a partir de hoy, y en su caso mientras mantengamos relación jurídica. Acepto que este documento queda bajo propiedad de CONDUCE CAPITAL SAPI DE CV. para efectos de control y cumplimiento del artículo 28 de la LRSIC.
                        </span>
                    </div>
                </div>

                <div className="ButtonWithShadow">
                    <Button
                        label='Autorizo'
                        className='Green py-3 mt-4'
                        //disabled={!canContinue() && !loading}
                        onClick={buroRequest}
                    />
                    <div className="Shadow">
                    </div>
                </div>
            </div>
        </div>
    );
}

export {Buro2};